import { getVar } from "config";
import { Warnings, trackWarning } from "modules/monitoring";

interface DNSQueryAnswer {
  name?: string;
  type?: number;
  TTL?: number;
  data?: string;
}

interface DNSQueryResult {
  Answer: DNSQueryAnswer[];
}

export const checkCName = async (domain: string): Promise<boolean> => {
  const allowedHost = getVar("REACT_APP_REMO_HOST");
  try {
    const resp = await fetch(
      `https://dns.google.com/resolve?name=${domain}&type=CNAME`,
    );

    if (resp?.status === 200) {
      const jsonData: DNSQueryResult = await resp.json();
      const answers = jsonData.Answer || [];

      return answers.some((answer) => {
        // removes dot at end of string if present
        const name = answer.name ? answer.name.slice(0, -1) : false;
        const data = answer.data ? answer.data.slice(0, -1) : false;

        return name && data && name === domain && allowedHost === data;
      });
    }
  } catch (error) {
    if (error instanceof Error) {
      trackWarning(Warnings.CNAME_CHECK_FAILED, {
        message: `Error encountered while performing custom domain cname check: "${error.message}"`,
      });
    }
  }

  return false;
};
